enum DraftType {
  COMPANY = "company",
  CONTACT = "contact",
  ACTIVITY = "crmActivity",
  DEAL = "deals",
  NOTE = "notes",
  EMAIL = "email",
  FIELD = "field",
}

export default DraftType;
